import React from 'react';
import { Link } from 'react-router-dom';

const categories = [
  {
    name: 'Hair',
    slug: 'hair',
    description:
      'Cuts, styling, wash and finish, colour support, treatment journeys, and look-led consultations.',
    examples: ['Cuts and styling', 'Colour and tone refresh', 'Hair treatments'],
  },
  {
    name: 'Beard',
    slug: 'beard',
    description:
      'Grooming, shaping, beard styling, and barber-led care for routine and occasion-based visits.',
    examples: ['Beard trimming', 'Line shaping', 'Grooming packages'],
  },
  {
    name: 'Nails',
    slug: 'nails',
    description:
      'Routine nail care, design-led appointments, occasion styling, and specialist treatments.',
    examples: ['Gel nails', 'Nail art', 'Care and finish'],
  },
  {
    name: 'Tattoo',
    slug: 'tattoo',
    description:
      'Artist discovery, style-aware portfolio exploration, and future booking journeys for tattoo work.',
    examples: ['Custom pieces', 'Black and grey', 'Consultation-led sessions'],
  },
  {
    name: 'Piercing',
    slug: 'piercing',
    description:
      'Trusted provider discovery for piercing services with an emphasis on safety, aftercare, and clarity.',
    examples: ['Ear piercing', 'Body piercing', 'Aftercare guidance'],
  },
  {
    name: 'Beauty',
    slug: 'beauty',
    description:
      'A broader category for beauty-focused services as HnB expands its customer and provider experience.',
    examples: ['Beauty consultations', 'Occasion-ready services', 'Emerging categories'],
  },
];

const stylists = [
  {
    name: 'Amelia Reid',
    category: 'Hair',
    rating: '4.9',
    note: 'Editorial colour work and precision styling.',
  },
  {
    name: 'Haris Malik',
    category: 'Beard',
    rating: '4.8',
    note: 'Sharp grooming, line work, and modern barbering.',
  },
  {
    name: 'Sofia Khan',
    category: 'Nails',
    rating: '4.9',
    note: 'Design-led nail work with premium finish details.',
  },
  {
    name: 'Luca Byrne',
    category: 'Tattoo',
    rating: '4.8',
    note: 'Portfolio-driven custom sessions and consultation flow.',
  },
];

export default function ServicesPage() {
  return (
    <main style={{ background: '#f8fafc', color: '#0f172a', minHeight: '100vh' }}>
      <section
        style={{
          padding: '72px 24px 56px',
          background: '#ffffff',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1120px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
          }}
        >
          <p
            style={{
              margin: 0,
              color: '#4f46e5',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              fontSize: '0.9rem',
            }}
          >
            Services
          </p>

          <h1 style={{ margin: 0, fontSize: '3rem', lineHeight: 1.08, maxWidth: '12ch' }}>
            Explore service categories across the HnB platform
          </h1>

          <p
            style={{
              margin: 0,
              color: '#475569',
              fontSize: '1.05rem',
              lineHeight: 1.8,
              maxWidth: '72ch',
            }}
          >
            HnB’s public services layer is intended to help customers understand
            categories quickly, compare providers more clearly, and move toward
            trusted discovery, AI-supported inspiration, and booking.
          </p>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <Link
              to="/find-provider"
              style={{
                textDecoration: 'none',
                background: '#111827',
                color: '#ffffff',
                padding: '13px 18px',
                borderRadius: '10px',
                fontWeight: 600,
              }}
            >
              Find a provider
            </Link>

            <Link
              to="/ai-plans"
              style={{
                textDecoration: 'none',
                background: '#ffffff',
                color: '#111827',
                padding: '13px 18px',
                borderRadius: '10px',
                fontWeight: 600,
                border: '1px solid #d1d5db',
              }}
            >
              View AI plans
            </Link>
          </div>
        </div>
      </section>

      <section style={{ padding: '56px 24px' }}>
        <div
          style={{
            maxWidth: '1120px',
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
            gap: '18px',
          }}
        >
          {categories.map((category) => (
            <div
              key={category.slug}
              style={{
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderRadius: '18px',
                padding: '22px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              <h2 style={{ margin: 0, fontSize: '1.2rem' }}>{category.name}</h2>
              <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.75 }}>
                {category.description}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {category.examples.map((item) => (
                  <span
                    key={item}
                    style={{
                      display: 'inline-flex',
                      padding: '8px 10px',
                      borderRadius: '999px',
                      background: '#eef2ff',
                      color: '#4338ca',
                      fontSize: '0.9rem',
                      fontWeight: 600,
                    }}
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          padding: '56px 24px',
          background: '#ffffff',
          borderTop: '1px solid #e5e7eb',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            maxWidth: '1120px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '22px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <p
              style={{
                margin: 0,
                color: '#4f46e5',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                fontSize: '0.85rem',
              }}
            >
              Highest rated stylists
            </p>
            <h2 style={{ margin: 0, fontSize: '2rem' }}>
              Example public spotlight for category-wise talent
            </h2>
            <p style={{ margin: 0, color: '#64748b', lineHeight: 1.75, maxWidth: '70ch' }}>
              Your earlier HnB notes explicitly called for public visibility of
              highly rated stylists and work samples by service category, so this
              section can later connect to live provider, review, and portfolio data.
            </p>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '16px',
            }}
          >
            {stylists.map((stylist) => (
              <div
                key={stylist.name}
                style={{
                  background: '#f8fafc',
                  border: '1px solid #e5e7eb',
                  borderRadius: '18px',
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <div
                  style={{
                    width: '52px',
                    height: '52px',
                    borderRadius: '999px',
                    background: '#c7d2fe',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    color: '#312e81',
                  }}
                >
                  {stylist.name
                    .split(' ')
                    .map((part) => part[0])
                    .join('')}
                </div>
                <h3 style={{ margin: 0, fontSize: '1.08rem' }}>{stylist.name}</h3>
                <p style={{ margin: 0, color: '#4338ca', fontWeight: 600 }}>
                  {stylist.category} · {stylist.rating} stars
                </p>
                <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.7 }}>{stylist.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: '64px 24px 72px' }}>
        <div
          style={{
            maxWidth: '980px',
            margin: '0 auto',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '18px',
            alignItems: 'center',
          }}
        >
          <h2 style={{ margin: 0, fontSize: '2.1rem', lineHeight: 1.15 }}>
            Continue from service discovery into provider comparison
          </h2>
          <p style={{ margin: 0, color: '#64748b', lineHeight: 1.8, maxWidth: '62ch' }}>
            The next public layers can help customers compare providers, review
            AI pricing, and build confidence before they enter booking flows.
          </p>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link
              to="/find-provider"
              style={{
                textDecoration: 'none',
                background: '#111827',
                color: '#ffffff',
                padding: '13px 18px',
                borderRadius: '10px',
                fontWeight: 600,
              }}
            >
              Find provider
            </Link>

            <Link
              to="/ai-plans"
              style={{
                textDecoration: 'none',
                background: '#ffffff',
                color: '#111827',
                padding: '13px 18px',
                borderRadius: '10px',
                fontWeight: 600,
                border: '1px solid #d1d5db',
              }}
            >
              AI plans
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}